import { z } from 'zod';
import { MEASUREMENT_KINDS } from '../constants.ts';

export const measurementKindSchema = z.enum(MEASUREMENT_KINDS);

export const measurementCreateSchema = z.object({
  occurred_at: z.number().int().optional(),
  kind: measurementKindSchema,
  /** Smallest-unit integer: grams for weight, mm for length / head. */
  value: z.number().int().min(1).max(200_000),
  notes: z.string().max(2000).nullable().optional(),
});

export const measurementPatchSchema = measurementCreateSchema.partial();

export type MeasurementCreateInput = z.infer<typeof measurementCreateSchema>;
export type MeasurementPatchInput = z.infer<typeof measurementPatchSchema>;
